import { formatRollerDisplay } from '../../../../helpers/format-roller-display'
import { onCellStandard } from '../../helpers/helpers'
import { DataSourceItem } from '../../shipments-page'
import type { ShipmentColumn } from '../../types/column-types'

export const stampRollerRollerColumn: ShipmentColumn = {
    dataIndex: ['stamp', 'roller', 'roller'],
    title: 'Вал',
    width: 50,
    render: (v: string, r: DataSourceItem) =>
        formatRollerDisplay(
            r.withoutCutting ? r.virtualStamp?.roller?.roller : r.stamp?.roller?.roller
        ),
    onCell: onCellStandard,
}
